import React from 'react';
import styled, { keyframes } from '@secretescapes/falcon';

const loadingSkeletonAnimation = keyframes`
  0% {
    transform: translate(-100%);
  }

  100% {
    transform: translate(100%);
  }
`;

export interface LoadingSkeletonSectionProps {
  className?: string;
  height?: string;
  width?: string;
  borderRadius?: string;
}

export const Bar = styled('div')`
  width: 100%;
  animation-duration: 1.2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${loadingSkeletonAnimation};
  animation-timing-function: linear;
  background-color: ${({ theme }) => theme?.color?.grey05};
  background-image: linear-gradient(
    to right,
    transparent 25%,
    ${({ theme }) => theme?.color?.white} 50%,
    transparent 75%
  );
  background-repeat: 'no-repeat';
`;

const Container = styled('div')<LoadingSkeletonSectionProps>`
  display: flex;
  height: ${({ height }) => height ?? '200px'};
  width: ${({ width }) => width ?? '100%'};
  ${({ borderRadius }) => (borderRadius ? `border-radius: ${borderRadius};` : '')}
  background: ${({ theme }) => theme?.color?.grey05};
  overflow: hidden;
`;

export const LoadingSkeletonSection = ({
  className,
  height,
  width,
  borderRadius,
}: LoadingSkeletonSectionProps) => {
  return (
    <Container className={className} height={height} width={width} borderRadius={borderRadius}>
      <Bar />
    </Container>
  );
};
